<template>
	<v-card>
		<v-card-title>Citas del día</v-card-title>
		<v-data-table
			:headers="encabezados"
			:items="citas"
			:items-per-page="5"
			class="elevation-1"
			:multi-sort="true"
			@click:row="citaSeleccionada"
		>
		</v-data-table>
	</v-card>
</template>

<script>
export default {
	name: 'CitasDelDia',
	props: {
		citas: {
			type: Array,
			required: true
		}
	},
	data: () => ({
		encabezados: [
			{text: 'Folio', value: 'idCita'},
			{text: 'Fecha', value: 'fechaCita'},
			{text: 'Hora', value: 'horaCita'},
			{text: 'Nombre del Paciente', value: 'paciente'},
			{text: 'Nombre del Terapeuta', value: 'terapeuta'},
			{text: 'Núm. Sesión', value: 'numCita'}
		],
	}),
	methods: {
		citaSeleccionada(event){
			let datosDeCita =  {
				idCita: event.idCita,
				fecha: event.fechaCita,
				hora: event.horaCita,
				paciente: event.paciente,
				terapeuta: event.terapeuta,
				numCita: event.numCita
			}
			console.log("Cita Seleccionada", event)
			this.$emit("cita-seleccionada", datosDeCita)
		}
	},
}
</script>
